import { ReactMultiEmail } from "react-multi-email"

interface Props {
  emails: string[]
  onEmailsChange: (emails: string[]) => void
}

export default function EmailInput({ emails, onEmailsChange }: Props) {
  return (
    <form>
      <ReactMultiEmail
        placeholder="Type email(s), separated by commas"
        emails={emails}
        onChange={onEmailsChange}
        autoFocus={true}
        getLabel={(email, index, removeEmail) => (
          <div data-tag key={index}>
            <div data-tag-item>{email}</div>
            <span data-tag-handle onClick={() => removeEmail(index)}>
              ×
            </span>
          </div>
        )}
      />
    </form>
  )
}
